import React, { useEffect, useLayoutEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import CrossGrayIcon from '../../common/images-new/cross-gray-icon.svg'
import ButtonBlue from '../../components/Button/ButtonBlue'
import { staticFiles } from '../../components/Helpers/Static'
import SharePostCardExport from '../../pages/Community/SharePostCardExport';
import { emptyList } from '../../redux/actions/sharePost';
import { getImagePools, getSystemThemes } from '../../redux/actions/auth';
import ShowcaseOption from './ShowcaseOption';

import axios from 'axios';
import { apiMainUrl, serverUrl } from '../Helpers/Config';
import { Card } from '../../pages/Theme';
import ModalProfile from './ModalProfile';

const CROSS_GRAY_ICON = staticFiles.cross;

const ModalTheme = ({ showModalEditCover, setshowModalEditCover, setThemeId }) => {
    const dispatch = useDispatch()
    const userProfile = useSelector(state => state.auth.user)
    const systemThemes = useSelector(state => state.auth.systemTheme)
    const isLoading = useSelector(state => state.export.isLoading)
    const [initialLoad, setinitialLoad] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const coverImageRef = useRef();
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [profilePhoto, setProfilePhoto] = useState();
    const [profilePhotoFile, setProfilePhotoFile] = useState(null);
    const [showProfile, setShowProfile] = useState(false);
    const [isshowImage, setisshowImage] = useState(false);
    const [isUpload, setisUpload] = useState(false);
    // const [chooseImages, setchooseImages] = useState([]);

    // const tabs = [{ text: 'Upload Image', id: 1 }, { text: 'Image Library', id: 2 }]

    const tabs = [{ text: 'Image Library', id: 1 }]

    const profile = {
        name: userProfile ? userProfile.fullname : '',
        email: userProfile ? userProfile.email : '',
        programme: userProfile ? userProfile.programme : '',
        photo: userProfile ? userProfile.photo : '',
        cover: userProfile ? userProfile.cover : ''
    }

    const showHideModal = showModalEditCover
        ? 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex'
        : 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden'

    function close() {
        setshowModalEditCover(false);
        setisshowImage(false);
    }

    // function switchTab(id) {
    //     setCurrentPage(id)
    //     // setCheckedList([]) 
    // }

    // const handleCoverImageChange = (e) => {
    //     setProfilePhotoFile(null);
    //     const fileObj = e.target.files[0];
    //     if (!fileObj) return;
    //     setProfilePhotoFile(fileObj);
    //     setShowProfile(true)
    // }

    // const handleChooseEditCover = (image) => {
    //     setisUpload(false);
    //     setProfilePhotoFile(null);
    //     setProfilePhotoFile(image);
    //     setShowProfile(true);
    // }

    const handlethemeChange = (id, data) => {
        setThemeId(id);
        if (id === 0) {
            dispatch({
                type: 'GET_USER_DEFAULT_THEME',
                payload: "",
            });
        } else {
            dispatch({
                type: 'GET_USER_THEME',
                payload: data,
            });
        }
    }

    useEffect(() => {
        if (profilePhotoFile) {
            if (isUpload == true) {
                const objectURL = URL.createObjectURL(profilePhotoFile);
                setProfilePhoto(objectURL);
                return () => URL.revokeObjectURL(objectURL);
            }
            if (isUpload == false) {
                const byteCharacters = atob(profilePhotoFile?.pool_image?.split(',')[1]);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'image/png' });
                // Create a Blob URL
                const blobURL = URL.createObjectURL(blob);
                setProfilePhoto(blobURL);
                return () => URL.revokeObjectURL(blobURL);
            }
        }
    }, [profilePhotoFile]);

    useEffect(() => {
        dispatch(getSystemThemes())
    }, [])

    const handleUpload = () => {
        coverImageRef.current.value = ""
        setisUpload(true)
        coverImageRef.current.click()
    }

    return (
        <div className={showHideModal} onClick={(e) => e.stopPropagation()}>
            <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4">
                <Card className="w-80 md:w-full bg-white px-4 md:px-8 py-5 my-5 rounded-md filter drop-shadow-md ">

                    <p className="font-bold flex justify-center text-xl mb-3">{"Choose Theme"}</p>
                    <img
                        className="absolute right-4 md:right-8 top-6 cursor-pointer hover:opacity-60"
                        onClick={close} alt="cross" src={CROSS_GRAY_ICON}>
                    </img>
                    <hr className='w-full border-gray-300 mb-3' />
                    <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-5 justify-center p-30px">
                        <div className='overflow-auto max-h-96'>
                            {systemThemes?.length > 0 ?
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 p-10px">
                                    <div className='row cursor-pointer bg-gray-200 p-4 rounded-lg' onClick={() => handlethemeChange(0, 0)}>
                                        <div className='col-12 pb-2'>
                                            <p class="truncate h-30px font-semibold">{"Default themeeee"}</p>
                                        </div>
                                        <div className='flex grid grid-cols-8 col-12 bg-white p-1 rounded-md'>
                                            <div className='color-div-theme rounded-l-md' style={{ backgroundColor: `#F3F6F6` }}></div>
                                            <div className='color-div-theme' style={{ backgroundColor: `#2084D4` }}></div>
                                            <div className='color-div-theme' style={{ backgroundColor: `#31658e` }}></div>
                                            <div className='color-div-theme' style={{ backgroundColor: `white` }}></div>
                                            <div className='color-div-theme' style={{ backgroundColor: `black` }}></div>
                                            <div className='color-div-theme' style={{ backgroundColor: `#9ca3af` }}></div> 
                                            <div className='color-div-theme' style={{ backgroundColor: `#969696` }}></div>
                                            <div className='color-div-theme rounded-r-md' style={{ backgroundColor: `#dc2626` }}></div>
                                        </div>
                                    </div>
                                    {systemThemes?.map((i) => (<>
                                        <div className='row cursor-pointer bg-gray-200 p-4 rounded-lg' onClick={() => handlethemeChange(i.id, i)}>
                                            <div className='col-12 pb-2'>
                                                <p class="truncate h-30px font-semibold">{i?.theme_name}</p>
                                            </div>
                                            <div className='flex grid grid-cols-8 col-12 bg-white p-1 rounded-md'>
                                                <div className='color-div-theme rounded-l-md' style={{ backgroundColor: `${i.color1}` }}></div>
                                                <div className='color-div-theme' style={{ backgroundColor: `${i.color2}` }}></div>
                                                <div className='color-div-theme' style={{ backgroundColor: `${i.color3}` }}></div>
                                                <div className='color-div-theme' style={{ backgroundColor: `${i.color4}` }}></div>
                                                <div className='color-div-theme' style={{ backgroundColor: `${i.color5}` }}></div>
                                                <div className='color-div-theme' style={{ backgroundColor: `${i.color6}` }}></div>
                                                <div className='color-div-theme' style={{ backgroundColor: `${i.color7}` }}></div>
                                                <div className='color-div-theme rounded-r-md' style={{ backgroundColor: `${i.color8}` }}></div>
                                            </div>
                                        </div>
                                    </>))}
                                </div> :
                                <div className='grid grid-cols-1 p-5'>
                                    <div class="font-semibold">No Themes Found</div>
                                </div>}
                        </div>
                    </div>
                </Card>
            </section>
        </div >
    )
}

export default ModalTheme